/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EvaluationParameterScopeDto } from './EvaluationParameterScopeDto';
import {
    EvaluationParameterScopeDtoFromJSON,
    EvaluationParameterScopeDtoFromJSONTyped,
    EvaluationParameterScopeDtoToJSON,
} from './EvaluationParameterScopeDto';
import type { ParameterCombinationDto } from './ParameterCombinationDto';
import {
    ParameterCombinationDtoFromJSON,
    ParameterCombinationDtoFromJSONTyped,
    ParameterCombinationDtoToJSON,
} from './ParameterCombinationDto';
import type { TrackItTaskResultForEvaluation } from './TrackItTaskResultForEvaluation';
import {
    TrackItTaskResultForEvaluationFromJSON,
    TrackItTaskResultForEvaluationFromJSONTyped,
    TrackItTaskResultForEvaluationToJSON,
} from './TrackItTaskResultForEvaluation';

/**
 * 
 * @export
 * @interface ImportTrackItMeasurementForTaskAreaDto
 */
export interface ImportTrackItMeasurementForTaskAreaDto {
    /**
     * 
     * @type {string}
     * @memberof ImportTrackItMeasurementForTaskAreaDto
     */
    resultId?: string | null;
    /**
     * 
     * @type {Array<TrackItTaskResultForEvaluation>}
     * @memberof ImportTrackItMeasurementForTaskAreaDto
     */
    additionalResults: Array<TrackItTaskResultForEvaluation>;
    /**
     * 
     * @type {number}
     * @memberof ImportTrackItMeasurementForTaskAreaDto
     */
    trackItMeasurementId: number;
    /**
     * 
     * @type {ParameterCombinationDto}
     * @memberof ImportTrackItMeasurementForTaskAreaDto
     */
    combination: ParameterCombinationDto;
    /**
     * 
     * @type {Array<EvaluationParameterScopeDto>}
     * @memberof ImportTrackItMeasurementForTaskAreaDto
     */
    evaluationParameterScopes: Array<EvaluationParameterScopeDto>;
    /**
     * 
     * @type {string}
     * @memberof ImportTrackItMeasurementForTaskAreaDto
     */
    $type?: ImportTrackItMeasurementForTaskAreaDtoTypeEnum;
}


/**
 * @export
 */
export const ImportTrackItMeasurementForTaskAreaDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoImportTrackItMeasurementForTaskAreaDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.ImportTrackItMeasurementForTaskAreaDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ImportTrackItMeasurementForTaskAreaDtoTypeEnum = typeof ImportTrackItMeasurementForTaskAreaDtoTypeEnum[keyof typeof ImportTrackItMeasurementForTaskAreaDtoTypeEnum];



/**
 * Check if a given object implements the ImportTrackItMeasurementForTaskAreaDto interface.
 */
export function instanceOfImportTrackItMeasurementForTaskAreaDto(value?: unknown): value is ImportTrackItMeasurementForTaskAreaDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ImportTrackItMeasurementForTaskAreaDtoTypeEnum)[0];
}

export function ImportTrackItMeasurementForTaskAreaDtoFromJSON(json: any): ImportTrackItMeasurementForTaskAreaDto {
    return ImportTrackItMeasurementForTaskAreaDtoFromJSONTyped(json, false);
}

export function ImportTrackItMeasurementForTaskAreaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportTrackItMeasurementForTaskAreaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'resultId': json['resultId'] == null ? undefined : json['resultId'],
        'additionalResults': ((json['additionalResults'] as Array<any>).map(TrackItTaskResultForEvaluationFromJSON)),
        'trackItMeasurementId': json['trackItMeasurementId'],
        'combination': ParameterCombinationDtoFromJSON(json['combination']),
        'evaluationParameterScopes': ((json['evaluationParameterScopes'] as Array<any>).map(EvaluationParameterScopeDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ImportTrackItMeasurementForTaskAreaDtoToJSON(value?: ImportTrackItMeasurementForTaskAreaDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'resultId': value['resultId'],
        'additionalResults': ((value['additionalResults'] as Array<any>).map(TrackItTaskResultForEvaluationToJSON)),
        'trackItMeasurementId': value['trackItMeasurementId'],
        'combination': ParameterCombinationDtoToJSON(value['combination']),
        'evaluationParameterScopes': ((value['evaluationParameterScopes'] as Array<any>).map(EvaluationParameterScopeDtoToJSON)),
        '$type': value['$type'],
    });
}

